import { Button } from "@/components/ui/button/button";

import { useSaveButton } from "./hooks/use-save-button";

export const HeaderSaveButton = () => {
	const { isValid, onSave } = useSaveButton();

	return (
		<Button variant={isValid ? "outline" : "disabled"} size={"xl"} onClick={onSave}>
			公開せずに保存
		</Button>
	);
};
